import React, { useRef, useContext } from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom'
import { AudioProvider } from 'rewact'
import { ModalProvider } from 'modaaals'
import Analytics from 'react-router-ga'

import TrackContext from './context/TrackContext'
import { App } from './components/App'
import { Home } from './components/Home'
import { Player } from './components/Player'
import * as Profile from './components/Profile'
import { modals, globalStyles } from './components/Modals'

function Wrapper() {
  const fileRef = useRef(null)
  const { loop, playerTrack } = useContext(TrackContext)

  fileRef.current = playerTrack
    ? `${process.env.REACT_APP_TRACK_URI}/${playerTrack.slug}.mp3`
    : null

  return (
    <Router>
      <Analytics id="UA-168806660-1">
        <AudioProvider src={fileRef.current} loop={loop}>
          <ModalProvider
            modals={modals}
            drag={false}
            styles={globalStyles}
            skipMotion
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
              }}
            >
              <Switch>
                <Route path="/app">
                  <App />
                </Route>
                <Route path="/profile">
                  <ProfileInner />
                </Route>
                <Route path="/login" exact>
                  <Profile.Login />
                </Route>
                <Route path="/reset" exact>
                  <Profile.ResetPassword />
                </Route>
                <Route path="/" exact>
                  <Home />
                </Route>
              </Switch>
              <Player />
            </div>
          </ModalProvider>
        </AudioProvider>
      </Analytics>
    </Router>
  )
}

export default Wrapper

function ProfileInner() {
  let { path } = useRouteMatch()

  return (
    <Profile.Profile>
      <Switch>
        <Route exact path={path}>
          <Profile.Home />
        </Route>
        <Route path={`${path}/quote/:itemId`}>
          <Profile.RequestItem kind="quote" />
        </Route>
        <Route path={`${path}/supervision/:itemId`}>
          <Profile.RequestItem kind="supervision" />
        </Route>
        <Route path={`${path}/purchased/:itemId`}>
          <Profile.RequestItem kind="purchased" />
        </Route>
        <Route path={`${path}/contact`}>
          <Profile.Contact />
        </Route>
        <Route path={`${path}/billing-information`}>
          <Profile.BillingInfo />
        </Route>
        <Route path={`${path}/ask-supervision`}>
          <Profile.AskSupervision />
        </Route>
      </Switch>
    </Profile.Profile>
  )
}

// function ScrollToTop() {
//   const { pathname } = useLocation()

//   useLayoutEffect(() => {
//     window.scrollTo(0, 0)
//   }, [pathname])

//   return null
// }
